$(document).on('click', 'a[href^="#"]', function (e) {
    const $body = $('html, body');
    e.preventDefault();
    const scrollTop = $($(this).attr('href')).offset().top;
    $body.animate({ scrollTop }, 500);
});


// $('a[href*="#"]:not([href="#"])').on('click', function (e) {

//     if ($("#machlist").length > 0) {
//         $('html,body').stop().animate({
//             scrollTop: $("#machlist").offset().top - 350 //offsets for fixed header
//         }, 'linear');
//     };
// });